// @flow

import type {
  Asset,
  AssetsById,
} from 'fc-model-assets/types'

// Libs
import { createSelector } from 'reselect'
import _reduce from 'lodash/reduce'
import { geomEach } from '@turf/meta'
import { feature, featureCollection } from '@turf/helpers'

// Constants
import {
  PROP_ASSET_ID,
  PROP_SHAPE,
} from 'fc-model-assets'

import {
  PROP_SHAPE_DATA,
} from 'fc-model-shapes'

// Selectors
import assets$ from './assets'
import childrenIndex$ from './childrenIndex'

// Local
type Geometry = { type: string, coordinates: Array<*>, properties: Object }
type Feature = {
  type: 'Feature',
  properties: Object,
  geometry: Geometry
}

type Index = {
  [number]: {
    type: 'FeatureCollection',
    properties: Object,
    features: Array<Feature>
  }
}

function collectFeatures (
  assets: AssetsById,
  children: { [number]: Array<number>},
  asset: Asset,
  featureCollectionPerAsset: Index
  //
): Array<Feature> {
  //
  if (featureCollectionPerAsset[asset[PROP_ASSET_ID]]) {
    return featureCollectionPerAsset[asset[PROP_ASSET_ID]].features
  }

  let geometries = []

  if (asset[PROP_SHAPE]) {
    geomEach(asset[PROP_SHAPE][PROP_SHAPE_DATA], function (geometry: Geometry) {
      geometries.push(geometry)
    })
  } else {
    // This will only be needed when an asset is incorrect set as a child of itself
    // in buildChildrenIndex$, otherwise if shape is null, initialized geom of []
    // is returned anyway.
    return []
  }

  const features = _reduce(
    children[asset[PROP_ASSET_ID]],
    function (acc: Array<Feature>, childId: number): Array<Feature> {
      return [
        ...acc,
        ...collectFeatures(assets, children, assets[childId], featureCollectionPerAsset),
      ]
    },
    geometries.map(function (geometry: Object): Object {
      return feature(geometry)
    }))

  featureCollectionPerAsset[asset[PROP_ASSET_ID]] = featureCollection(features)

  return features
}

// Exports
export default (createSelector(
  [assets$, childrenIndex$],
  function (assets: AssetsById, children: { [number]: Array<number>}): Index {
    return _reduce(assets, function (acc: Index, asset: Asset): Index {
      if (acc[asset[PROP_ASSET_ID]]) {
        return acc
      }

      collectFeatures(assets, children, asset, acc)
      window.fc = acc
      return acc
    }, {})
  }
): Selector$<Index>)
